<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Edit Node Server
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <router-link to="/admin/node-server" class="btn px-15 btn-secondary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-arrow-left fs-16"></i>
                                Back to List
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <EditNodeServer/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EditNodeServer from "@/components/forms/admin/EditNodeServer.vue";

    export default {
        components: {
            EditNodeServer
        }
    };
</script>
